import { render, staticRenderFns } from "./CoursesCreate.vue?vue&type=template&id=1599beae"
import script from "./CoursesCreate.vue?vue&type=script&lang=js"
export * from "./CoursesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports